import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TestActions = createActionGroup({
  source: 'Test',
  events: {
    Enter: emptyProps(),
    'Add Test Results': props<{ payload: any }>(),
  },
});
